
















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {InputText, InputCheckbox} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'

@Component({
  components: {InputText, InputCheckbox},
})
export default class InputWebhook extends Vue {
  @Prop({type: Responsavel, required: true}) model!: Responsavel

  get computedModel() {
    return this.model
  }

  set computedModel(val: Responsavel) {
    this.$emit('input', val)
  }
}
